import { IActionFn, IPageData } from '@/store/types';
import { $file, $http } from '@/axios';
import { IModuleState } from './types';
import { downloadFile } from '@/utils/helper';

// 查询组织统计信息
export const queryStatisticsAccounts: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setStatisticsAccounts', { ...state.list, loading: true });
    // const res: IPageData = await $http.post('/v1/finance/service/org', payload);
    const res: IPageData = await $http.post('/v1/stat/org/financestatus', payload);
    commit('setStatisticsAccounts', { data: res.list, total: res.total, pageNum: res.pageNum, pageSize: res.pageSize });
  } catch (e) {
    commit('setStatisticsAccounts', { data: [], total: 0, pageNum: 0, pageSize: 0 });
  }
};

// 导出日志
export const exportFinanceLogs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setLoading', true);
    // const res: { blob: Blob; filename: string; } = await $file.post('/v1/finance/service/logexport', payload);
    const res: { blob: Blob; filename: string; } = await $file.post('/v1/stat/org/financeoplog', payload);
    downloadFile(res.blob, res.filename);
  } finally {
    commit('setLoading', false);
  }
};
